import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { MdOpacity } from 'react-icons/md';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const SpareSalesMonthWiseBarLineGraph = ({ data }) => {
  if (!data || data.length === 0) return <div>No data available</div>;

  // Map month numbers (1–12) to names
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  // Define financial year order map (Apr–Jan)
  const monthOrder = {
    4: 1, 5: 2, 6: 3, 7: 4, 8: 5, 9: 6,
    10: 7, 11: 8, 12: 9, 1: 10
  };

  // Filter and sort: include Apr (4) → Jan (1)
  const filteredData = data
    .filter(item => {
      const m = parseInt(item.month, 10);
      return m >= 4 || m === 1;
    })
    .sort((a, b) => {
      const ma = parseInt(a.month, 10);
      const mb = parseInt(b.month, 10);
      return monthOrder[ma] - monthOrder[mb];
    });

  const labels = filteredData.map(item => monthNames[parseInt(item.month, 10) - 1]);
  const amountData = filteredData.map(item => item.amount);
  const partNoData = filteredData.map(item => item.part_no);

  const chartData = {
    labels,
    datasets: [
      {
        type: 'bar',
        label: 'Amount',
        data: amountData,
        backgroundColor: 'rgba(147,197,253,0.7)', // more visible opacity
        yAxisID: 'y1',
      },
      {
        type: 'line',
        label: 'Part No',
        data: partNoData,
        borderColor: '#3B82F6',
        backgroundColor: 'transparent',
        fill: false,
        yAxisID: 'y2',
        tension: 0.3,
        pointHoverRadius: 6,
        pointRadius: 4,
        hoverBorderColor: '#3B82F6',
      },
    ],

  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: { labels: { usePointStyle: true } },
      datalabels: { display: false },
    },
    scales: {
      x: { grid: { display: false } },
      y1: { type: 'linear', position: 'left', display: false, grid: { display: false } },
      y2: { type: 'linear', position: 'right', display: false, grid: { drawOnChartArea: false } },
    },
    hover: { mode: 'nearest', intersect: true },
  };

  return (
    <div className="w-full max-w-3xl mx-auto" style={{ height: '350px' }} >
      <Chart data={chartData} options={options} />
    </div >
  );
};

export default SpareSalesMonthWiseBarLineGraph;
